<template>
  <section class="activityImage-container" :style="{ backgroundImage: activityData.images.bg ? `url(${activityData.images.bg})` : 'none' }"></section>
</template>
<script>
import api from '@/services/api';

export default {
  name: 'ActivityImage',

  components: {},

  data() {
    return {
      template: null,
      activityData: {
        images: { bg: '' },
      },
    };
  },

  methods: {},

  mounted() {},

  beforeMount() {
    api
      .get(`activity/${this.$route.params.stream}`)
      .then((response) => {
        // console.log(response);
        let tempImages = { ...this.activityData.images };
        this.activityData = { ...this.activityData, ...response.data };
        this.activityData.images = response.data.images ? JSON.parse(response.data.images) : tempImages;
      })
      .catch((err) => {
        console.error(err);
      });
  },

  beforeDestroy() {},
};
</script>
<style scoped lang="scss">
.activityImage-container {
  background-color: var(--main-color);
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  position: relative;
  width: 100vw;
  height: 100dvh;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
